var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftOrangeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 33,
    viewBox: "0 0 18 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.687194 18.2828C0.247184 17.818 -7.51298e-07 17.1877 -7.22569e-07 16.5305C-6.93841e-07 15.8732 0.247184 15.2429 0.687194 14.7781L13.9647 0.756686C14.1812 0.519955 14.4402 0.33113 14.7265 0.201229C15.0129 0.0713285 15.3209 0.00295331 15.6325 9.34792e-05C15.9442 -0.00276635 16.2532 0.059947 16.5417 0.184573C16.8301 0.309199 17.0922 0.493242 17.3126 0.725964C17.5329 0.958686 17.7072 1.23542 17.8252 1.54004C17.9432 1.84465 18.0026 2.17103 17.9999 2.50013C17.9972 2.82924 17.9325 3.15448 17.8094 3.45688C17.6864 3.75927 17.5076 4.03278 17.2835 4.26142L5.66537 16.5305L17.2835 28.7995C17.711 29.267 17.9476 29.8931 17.9422 30.5429C17.9369 31.1928 17.69 31.8145 17.2549 32.274C16.8197 32.7336 16.231 32.9943 15.6156 32.9999C15.0002 33.0056 14.4073 32.7557 13.9647 32.3042L0.687194 18.2828Z",
    fill: "#F39422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftOrangeArrow);
export default __webpack_public_path__ + "static/media/left-orange-arrow.339587d0245413a55036e95918e934cc.svg";
export { ForwardRef as ReactComponent };